import _ from 'lodash';

export function shouldPassOnClick(path: EventTarget[]): boolean {
  for (const target of path) {
    if (!_.isElement(target)) {
      continue;
    }
    const element = target as Element;

    const ignoredTags: Set<string> = new Set(['a', 'input', 'button']);
    if (ignoredTags.has(element.tagName.toLowerCase())) {
      return false;
    }

    const ignoredClasses: Set<string> = new Set([
      'details-header',
      'MuiSvgIcon-root',
      'stop-click-propagation',
      'icon-container',
      'node-ellipsis', // JSON
    ]);
    for (const className of Array.from(element.classList)) {
      if (ignoredClasses.has(className)) {
        return false;
      }
    }
  }

  return true;
}
